import { Navigate, useSearchParams } from 'react-router';

// FLOW[46035]: «/v2/admin?tab=…» живёт как редирект в единый центр настроек.
// Старые ссылки (breadcrumbs, презентации уведомлений, закладки) не ломаются.

const TAB_TO_SECTION: Record<string, string> = {
  users: 'users',
  roles: 'roles',
  sessions: 'sessions',
  'api-keys': 'api-keys',
  partners: 'partners',
  documents: 'documents',
  policies: 'policies',
  firecrawl: 'firecrawl',
  saga: 'saga',
  'industry-erp': 'industry-erp',
};

export function V2AdminSettingsRedirect() {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const tab = params.get('tab') || 'users';
  params.delete('tab');
  // Легаси-формат intent=create-user → create=user (его читает UsersSection)
  if (params.get('intent') === 'create-user') {
    params.delete('intent');
    params.set('create', 'user');
  }
  const section = TAB_TO_SECTION[tab] || 'users';
  const qs = params.toString();
  return <Navigate to={`/v2/settings/${section}${qs ? `?${qs}` : ''}`} replace />;
}
